var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Box } from '@mui/material';
import * as Preact from 'preact';
import * as PartsList from './M_PartsList';
import * as HeroPropertySelections from './O_HeroPropertySelections';
import * as DrawerNavigation from './O_ProductDrawerNavigation';
export var Component = function (p) {
    return (Preact.h(Box, { sx: __assign({ width: { xs: '100%', md: '100%' }, height: '100%', backgroundColor: 'background.paper', display: 'flex', flexDirection: 'column', padding: '0px', boxSizing: 'border-box', position: { xs: 'absolute', md: 'relative' } }, p.sx) },
        Preact.h(DrawerNavigation.Component, { onCloseClick: p.onCloseClick, title: p.title, disableClose: p.disableClose }),
        Preact.h(Box, { padding: "12px", overflow: "auto" },
            p.heroProperties.heroProperties.length > 0 && (Preact.h(HeroPropertySelections.Component, { heroProperties: p.heroProperties.heroProperties, onColourClick: p.heroProperties.onColourClick, onHeroPropsClick: p.heroProperties.onHeroPropsClick, onHeroPartOptionClick: p.onHeroPartOptionClick, trackVariantSelection: p.heroProperties.trackVariantSelection, reorderDimensions: p.reorderDimensions })),
            Preact.h(PartsList.Component, { partsMetadata: p.parts.map(function (p) { return p.metadata; }), onPartClick: p.onPartClick, reorderDimensions: p.reorderDimensions }),
            p.extraContent)));
};
Component.displayName = 'ConfigurePanel';
